import { ICommunicationDashboardData } from 'src/apis/dashboard/dashboardCommunications.interfaces';

export const dashboardCommunicationsMock: ICommunicationDashboardData = {
  messaging: {
    totalMessages: 100,
    unreadCount: 10,
    sent: 100,
    received: 100,
    byType: {
      direct: 100,
      group: 100,
    },
  },
  announcements: {
    total: 100,
    active: 100,
    scheduled: 100,
    expired: 100,
    byAudience: {
      schoolWide: 100,
      classSpecific: 100,
    },
  },
  events: {
    total: 100,
    upcoming: 100,
    ongoing: 100,
    past: 100,
  },
  meetings: {
    total: 100,
    scheduled: 100,
    completed: 100,
    pending: 100,
    cancelled: 100,
  },
  engagement: {
    averageResponseTime: 100,
    responseRate: 100,
    activeParticipants: 100,
  },
  period: {
    startDate: '2024-01-01',
    endDate: '2024-12-31',
  },
};
